module.exports = __webpack_public_path__ + "images/cow-hero-placeholder.png";